import { BMInputField } from "@traveloka/district-bloom";
import IcSystemSearch from "@traveloka/icon-kit-web/react/IcSystemSearch";
import { Controller } from "react-hook-form";
import BMView from "../../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../../core/resource/MobileResourceProvider";
import SelectEmployeeDrawerDivisionFilter from "./SelectEmployeeDrawerDivisionFilter";

export default function SelectEmployeeDrawerHeader() {
  const { CorporateTravelerPicker: cr } = useMobileContentResource();

  return (
    <BMView row justify="between" spacing="md">
      <BMView flex>
        <Controller
          name="searchEmployee"
          render={({ field: { value, onChange } }) => (
            <BMInputField
              value={value as string}
              onChangeText={onChange}
              LeadingIcon={IcSystemSearch}
              placeholder={cr.searchEmployeeInputPlaceholder}
              returnKeyType="done"
              testID="search_employee-input"
            />
          )}
        />
      </BMView>
      <SelectEmployeeDrawerDivisionFilter />
    </BMView>
  );
}
